<template>
  <ListingBlockLayout
    class="listing-block listing-block--custom-lists"
    :title="view.pageTitle()"
    :numberOfColumns="4"
  >
    <CollectionCard
      v-for="doc in docsView.filteredDocs"
      :key="doc.id"
      :doc="doc"
      :view="docsView"
      :coverImages="docsView.coverImages(doc)"
    >
      <CustomListMenu
        v-if="!doc.is_standard"
        :list="doc"
        :listsView="docsView"
        positon="right"
      />
    </CollectionCard>

    <template #headerActions>
      <AppButton
        class="listing-block__new-list-btn"
        icon="iadd"
        @click="customListForm?.show"
        >Create List</AppButton
      >

      <CustomListForm
        ref="customListForm"
        class="listing-block__new-list-form"
        :view="createListFormView"
      />
    </template>
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import { computed, Raw, ref } from 'vue'
import { useRouter } from 'vue-router'

import { CreateCustomListForm, CustomListsView } from '@/models/custom.lists'
import { ListView } from '@/models/docs.list'

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import CollectionCard from '@/app/components/collections/card/CollectionCard.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import CustomListForm from '@/app/components/custom.lists/CustomListForm.vue'

const props = defineProps<{
  view: ListView
}>()

const docsView = computed(() => {
  return props.view.docs() as CustomListsView
})

const router = useRouter()

const customListForm = ref<InstanceType<typeof CustomListForm> | null>(null)
const createListFormView = ref<Raw<CreateCustomListForm>>(
  new CreateCustomListForm(undefined, true, router),
)
</script>

<style lang="scss" scoped>
.listing-block {
  :deep(.listing-block__inner) {
    @media (max-width: $w-tablet-s) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(235px, 1fr));
      overflow: visible;
    }
  }

  :deep(.custom-list-menu) {
    position: absolute;
    right: 16px;
    bottom: 16px;
  }

  :deep(.listing-block__new-list-btn .iconfont) {
    line-height: 1;
    margin-right: 4px;
  }
}
</style>
